module.exports = __webpack_public_path__ + "img/noimage.0af24fc4.svg";